import Prompt from 'components/Prompt';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import React, { Component } from 'react';

@observer
export class BlockUser extends Component {
  @observable reason = '';

  @computed get isValid() {
    return this.reason && this.reason !== '';
  }

  handleChanged = (field) => (value) => {
    this[field] = value;
  };

  handleSubmit = () => {
    const { sale } = this.props;
    if (sale.ui.prompt.onSubmit) {
      sale.ui.prompt.onSubmit({ reason: this.reason });
    }
  };

  render() {
    const { sale, t } = this.props;

    return (
      <Prompt
        {...sale.ui.prompt}
        opened={sale.ui.prompt.opened}
        onSubmit={this.handleSubmit}
        disablePrimaryButton={!this.isValid}
      >
        <div>
          <TextField
            label={t('Reason')}
            multiline
            name="reason"
            value={this.reason}
            onChanged={this.handleChanged('reason')}
            required
          />
        </div>
      </Prompt>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/Prompts/BlockUser.jsx